<div class="row form-row">
  <div class="col-sm-12">
    <h3>{{ 'events.registration.wizard.payment-info.modification-options-label' | translate | titlecase }}</h3>
  </div>
</div>
<div class="row form-row">
  <div class="col-sm-12">
    <label>
      <input
        type="checkbox"
        [(ngModel)]="registration.ModificationOptions.DoNotModifyInvoice"
        (ngModelChange)="handleDoNotModifyInvoiceChanged($event)"
      />
      {{ 'events.registration.wizard.payment-info.modification-options-do-not-modify-invoice-label' | translate | ucfirst }}
    </label>
  </div>
</div>

<div class="row form-row" *ngIf="registration.ModificationOptions.DoNotModifyInvoice == false && hasPaymentAmount">
  <div class="col-sm-6">
    <label>
      <input
        type="checkbox"
        [(ngModel)]="registration.ModificationOptions.CreateUnappliedPayments"
        (ngModelChange)="handleCreateUnappliedPaymentsChanged($event)"
      />

      {{ 'events.registration.wizard.payment-info.modification-options-create-unapplied-payments-label' | translate | titlecase }}
    </label>
  </div>
  <div class="col-sm-6" [hidden]="!hasRefundableCcPayment">
    <label>
      <input
        type="checkbox"
        [(ngModel)]="registration.ModificationOptions.RefundCreditCardPayments"
        (ngModelChange)="handleRefundCreditCardPaymentsChanged($event)"
      />

      {{ 'events.registration.wizard.payment-info.modification-options-refund-credit-card-payments-label' | translate | titlecase }}
    </label>
  </div>
</div>

<div class="row form-row" *ngIf="registration.ModificationOptions.DoNotModifyInvoice == false && hasPaymentAmount">
  <div class="col-sm-6">
    {{ 'events.registration.wizard.payment-info.modification-options-payment-adjustment-type-label' | translate | titlecase }}
  </div>
  <div class="col-sm-6">
    <wl-adjustment-type-selector
      [accountingPackageIds]="paymentAccountingPackageIds"
      [(ngModel)]="registration.ModificationOptions.PaymentAdjustmentTypeId"
    ></wl-adjustment-type-selector>
  </div>
</div>
<div class="row form-row" *ngIf="registration.ModificationOptions.DoNotModifyInvoice == false">
  <div class="col-sm-6">
    {{ 'events.registration.wizard.payment-info.modification-options-invoice-adjustment-type-label' | translate | titlecase }}
  </div>
  <div class="col-sm-6">
    <wl-adjustment-type-selector
      [accountingPackageIds]="lineItemAccountingPackageIds"
      [(ngModel)]="registration.ModificationOptions.InvoiceAdjustmentTypeId"
    ></wl-adjustment-type-selector>
  </div>
</div>
<div
  class="row form-row"
  *ngIf="registration.ModificationOptions.CreateUnappliedPayments && registration.ModificationOptions.DoNotModifyInvoice == false"
>
  <div class="col-sm-6">
    {{ 'events.registration.wizard.payment-info.modification-options-unapplied-payment-paymen-type-label' | translate | titlecase }}
  </div>
  <div class="col-sm-6">
    <wl-payment-type-selector [(ngModel)]="registration.ModificationOptions.UnappliedPaymentPaymentypeId"> </wl-payment-type-selector>
  </div>
</div>

<div class="row form-row">
  <div class="col-sm-3">
    {{ 'events.registration.wizard.payment-info.modification-options-notes-label' | translate | titlecase }}
  </div>
  <div class="col-sm-9">
    <textarea class="form-control" [(ngModel)]="registration.ModificationOptions.Notes"></textarea>
  </div>
</div>
